import { Stack } from '@mui/joy';
import { useDroppable } from '@dnd-kit/core';
import { MealTypeSection } from '@/features/meals/components/MealTypeSection';
import { AddMealButton } from '@/features/meals/components/AddMealButton';
import { EmptyMealTypeState } from '@/features/meals/components/EmptyMealTypeState';
import { DraggableMealEntry } from './DraggableMealEntry';
import { resolveMealPlanEntryItem } from '../utils/resolveMealPlanEntryItem';
import { localDateToString } from '@/utils/datetime';

export function MealPlanMealTypeSection({ mealType, entries, recipes, ingredients, events, householdId, date, isEditable, onAddMeal, isDragging, entryVariant, compactAddButton }) {
  const mealEntries = entries.filter((e) => e.meal_type === mealType);
  const dateString = localDateToString(date);
  const dropId = `drop-${dateString}-${mealType}`;
  const isEmpty = mealEntries.length === 0;

  return (
    <MealTypeSection mealType={mealType} isDragging={isDragging}>
      <Stack gap={0.75}>
        {mealEntries.map((entry) => {
          const resolved = resolveMealPlanEntryItem(entry, { recipes, ingredients, events });
          if (!resolved) return null;
          return (
            <DraggableMealEntry
              key={entry.id}
              entry={entry}
              kind={resolved.kind}
              item={resolved.item}
              householdId={householdId}
              isEditable={isEditable}
              originalDate={date}
              originalMealType={mealType}
              variant={entryVariant}
            />
          );
        })}
        {isEditable ? (
          <DroppableAddMealButton id={dropId} date={date} mealType={mealType} isEmpty={isEmpty} isDragging={isDragging} onClick={() => onAddMeal(mealType)} compact={compactAddButton} />
        ) : (
          isEmpty && <EmptyMealTypeState isDragging={isDragging} />
        )}
      </Stack>
    </MealTypeSection>
  );
}

function DroppableAddMealButton({ id, date, mealType, isEmpty, isDragging, onClick, compact }) {
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: { date, mealType, isEditable: true },
  });

  return (
    <AddMealButton
      ref={setNodeRef}
      mealType={mealType}
      isEmpty={isEmpty}
      isOver={isOver}
      isDragging={isDragging}
      onClick={onClick}
      compact={compact}
    />
  );
}
